import { zergApi } from "@/service/zerg";

class HomeworkStatusService {
    BASE_URL = "setting/homework-status";

    async getHomeworkStatuses(params) {
      const url = `${this.BASE_URL}/get-list`;
      try {
        const data = await zergApi.post(url,params);
        return data;
      } catch (error) {
        console.error(error);
      }
    }
    async getHomeworkStatus(params) {
        const url = `${this.BASE_URL}/get-homework-status`;
        try {
          const data = await zergApi.post(url, params);
          return data;
        } catch (error) {
          console.error(error);
        }
      }
      async setHomeworkStatus(params) {
        const url = `${this.BASE_URL}/set-homework-status`;
        try {
          const data = await zergApi.post(url, params);
          return data;
        } catch (error) {
          console.error(error);
        }
      }
      async updateHomeworkStatus(params) {
        const url = `${this.BASE_URL}/update-homework-status`;
        try {
          const data = await zergApi.post(url, params);
          return data;
        } catch (error) {
          console.error(error);
        }
      }
      async deleteHomeworkStatus(params) {
        const url = `${this.BASE_URL}/delete-homework-status`;
        try {
          const data = await zergApi.post(url, params);
          return data;
        } catch (error) {
          console.error(error);
        }
      }
      async getTrackingHomeworkStatus(params) {
        const url = `${this.BASE_URL}/get-tracking-homework-status`;
        try {
          const data = await zergApi.post(url, params);
          return data;
        } catch (error) {
          console.error(error);
        }
      }
  
 
}

export default new HomeworkStatusService();